import React from "react";

export const Microplastics = () => (
  <svg viewBox="0 0 512 512" width="512px" height="512px">
    <circle style={{ fill: "#E4F7FF" }} cx="148.73" cy="220.55" r="129.86" />
    <path
      style={{ fill: "#74FF91" }}
      d="M95.52,224.73l-1.89-13.76c1.24,0.85,7.11,9.36,7.11,9.36"
    />
    <path
      style={{ fill: "#6B00FF" }}
      d="M63.87,210.97l-14.09-5.16c9.26,0.32,53.13,3.51,53.13,3.51"
    />
    <path
      style={{ fill: "#D8FF00" }}
      d="M129.6,236.18l-4.16-15.75c2.73,0.97,15.68,10.71,15.68,10.71"
    />
    <path
      style={{ fill: "#726AFF" }}
      d="M118.08,189.04c3.41-0.4,28.26,4.75,28.26,4.75l1.06,14.25L118.08,189.04z"
    />
    <path
      style={{ fill: "#74FF91" }}
      d="M136.58,180.71l-15.37-11.43c1.31,0.36,12.3,5.97,12.3,5.97"
    />
    <path
      style={{ fill: "#00CA00" }}
      d="M112.93,170.91l-15.33-1.28c4.65-3.57,29.67-18.06,29.67-18.06"
    />
    <path
      style={{ fill: "#FF3FA2" }}
      d="M175.15,197.2l-19.86-13.37c2.15-0.08,18.29,4.4,18.29,4.4"
    />
    <path
      style={{ fill: "#00D4FF" }}
      d="M145.08,255.16c3.54,2.34,20.29,25.77,20.29,25.77l-14.91,12.11L145.08,255.16z"
    />
    <path d="M178.72,267.47l-16.74-7.83c11,0.48,63.14,5.33,63.14,5.33" />
    <path
      style={{ fill: "#CD75FF" }}
      d="M218.14,171.99c-4.88,0.63-30.35-3.34-30.35-3.34l16.4-15.05L218.14,171.99z"
    />
    <path
      style={{ fill: "#74FF91" }}
      d="M192.48,130.83l3.89,7.26c-0.99-0.12-6.53-3.23-6.53-3.23"
    />
    <path
      style={{ fill: "#6B00FF" }}
      d="M178.86,193.81l12.53,1.32c-1.97,1.55-14.72,7.59-14.72,7.59"
    />
    <path
      style={{ fill: "#FF3FA2" }}
      d="M174.26,224.73l22.75,4.33c-1.98,0.96-18.46,3.41-18.46,3.41"
    />
    <path
      style={{ fill: "#00D4FF" }}
      d="M178.5,182.11c-2.43-2.81-19.96-33.89-19.96-33.89l-0.42-19.85L178.5,182.11z"
    />
    <polygon
      style={{ fill: "#74FF91" }}
      points="75.5,268.44 69.63,268.44 56.32,235.17 75.5,232.75 "
    />
    <path
      style={{ fill: "#571A00" }}
      d="M102.89,248.56l39.4-3.14c-10.42,4.06-46.06,36.19-46.06,36.19"
    />
    <path
      style={{ fill: "#74FF91" }}
      d="M198.33,258.3l-4.01-19.32c2.64,1.19,15.14,13.14,15.14,13.14"
    />
    <path
      style={{ fill: "#D8FF00" }}
      d="M229.75,238.61l-8.85-22.11c5.82,1.37,33.39,15.04,33.39,15.04"
    />
    <path
      style={{ fill: "#00CA00" }}
      d="M200.8,228.58l-32.64-1.8c9.91-5.01,63.16-25.36,63.16-25.36"
    />
    <path
      d="M498.06,392.9L290.3,266.06c4.62-14.35,7.15-29.64,7.15-45.51c0-82.01-66.72-148.73-148.73-148.73
	S0,138.54,0,220.55c0,82.01,66.72,148.73,148.73,148.73c48.37,0,91.4-23.22,118.58-59.09l205.38,125.39
	c4.07,2.88,9.02,4.6,14.39,4.6c13.77,0,24.92-11.16,24.92-24.92C512,405.43,506.31,396.96,498.06,392.9z M148.73,331.55
	c-61.2,0-111-49.79-111-111c0-61.2,49.79-111,111-111s111,49.79,111,111C259.72,281.76,209.93,331.55,148.73,331.55z"
    />
  </svg>
);
